import React from 'react';
import '../../scss/components/LessonsPage/ModuleHexagon.scss';

const ModuleHexagon = ({ module, isActive, onClick, index }) => {
    const { title } = module;

    // Вычисляем индекс анимации внутри ряда (1, 2 или 3)
    const rowIndex = index % 3 + 1;

    return (
        <div
            className={`module-hexagon ${isActive ? 'active' : ''}`}
            onClick={onClick}
            style={{
                '--index': rowIndex
            }}
        >
            <div className="hexagon-shape">
                <div className="hexagon-content">
                    <h3 className="module-title">{title}</h3>
                    <div className="module-lessons-count">
                        <div className="lessons-number-container">
                            <div className="lessons-number-corners">
                                <div className="corner corner-bl"></div>
                                <div className="corner corner-br"></div>
                            </div>
                            <span className="lessons-number">{`МОДУЛЬ ${index + 1}`}</span>
                        </div>
                    </div>
                </div>

                <svg className="hexagon-border" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path d="M150 0 L200 86.6 L150 173.2 L50 173.2 L0 86.6 L50 0 Z" fill="none" stroke="currentColor" strokeWidth="2" />
                </svg>
            </div>
        </div>
    );
};



export default ModuleHexagon; 